import React, { useState } from 'react';
import { notifyInfo } from '@nutastic/nutastic-react-app';
import AboutModal from './AboutModal';
import PriceSheet from "./PriceSheet";

// eslint-disable-next-line react/prop-types
const Footer = ({ onToggleLinksPage }) => {
    const componentClass = 'footer';
    const copyrightYear = new Date().getFullYear();
    const [showModal, setShowModal] = useState(false);
    const [showPricesModal, setShowPricesModal] = useState(false);

    const onHomeButtonClick = () => {
        notifyInfo(null, null, <React.Fragment>It is where your heart is! Good vibes only <i className="ion-md-heart" /></React.Fragment>);
    };

    return <footer className={componentClass}>
        <div className={`${componentClass}__nav`} >
            <span onClick={onHomeButtonClick}>Home</span>
            <span onClick={() => setShowModal(true)}>About</span>
            <span onClick={() => setShowPricesModal(true)}>Prices</span>
            <span onClick={onToggleLinksPage}>Contact</span>
        </div>
        <div className={`${componentClass}__copyright`}>
            Manifesting Vibes &copy; {copyrightYear}. <a href="https://nutastic.net" target="_blank" className="nutasticLink" rel="noreferrer">Good Vibes Only.</a>
        </div>
        <AboutModal onClose={() => setShowModal(false)} isActive={showModal} />
        { showPricesModal && <PriceSheet isActive={true} onClose={() => setShowPricesModal(false)} /> }
    </footer>;
};

export default Footer;
